export const jaTranslation = {
      common: {
        loading: "読み込み中",
        loadingWithDots: "読み込み中です…",
        error: "エラーが発生しました",
        save: "保存",
        cancel: "キャンセル",
        search: "検索",
        logout: "ログアウト",
        close: "閉じる",
        back: "戻る",
        download: "ダウンロード",
        ascending: "昇順",
        descending: "降順",
        copy: "コピー",
        delete: "削除",
        confirm: "確定",
        yes: "はい",
        no: "いいえ",
        select: "選択",
        deselect: "選択解除",
        selectAll: "全て選択",
        noData: "データなし",
        noImage: "画像なし",
        processing: "処理中...",
        uploading: "アップロード中...",
        selectedCount: "選択中: {{count}}件",
        downloading: "ダウンロード中...",
        downloadCancel: "ダウンロードキャンセル",
        history: "履歴",
        done: "完了",
        input: "入力",
        import: "インポート",
        overwrite: "上書き",
        value: "値",
        register: "登録",
        comma: "、",
      },
      apiError: {
        fetchFailed: "データの取得に失敗しました。",
        retryHint: "画面を再読み込みするか、時間をおいて再度お試しください。",
      },
      language: {
        japanese: "日本語",
        english: "英語",
        switchLabel: "表示言語",
      },
      auth: {
        loginTitle: "ログイン",
        email: "メールアドレス",
        password: "パスワード",
        loginNow: "ログイン",
        forgotPassword: "パスワードをお忘れですか？",
        emailRequired: "メールアドレスを入力してください。",
        emailInvalid: "メールアドレスの形式が正しくありません。",
        passwordRequired: "パスワードを入力してください。",
        loginFailed: "ログインに失敗しました。",
        invalidCredentials: "メールアドレスまたはパスワードが違います。",
      },
      readonly: {
        description: "編集・保存はできません。",
        otherDepartment: "別部署のサンプルのため、閲覧のみ可能です。",
        adminMode: "管理者モードのため、閲覧のみ可能です。",
      },
      modal: {
        close: "モーダルを閉じる",
      },
      sample: {
        guest: "ゲスト",
        partNumber: "品番",
        sampleNumber: "サンプルNo",
        sampleStatus: "サンプル状況",
        size: "サイズ",
        colorNo: "カラーNo",
        repeat: "リピート",
        department: "所属部署",
        deviceName: "デバイス名",
        measurementDate: "検寸日時",
        date: "日付",
        user: "ユーザー",
        customerName: "顧客名",
        color: "カラー",
        departmentDropdown: "部署（プルダウン）",
        allDepartments: "すべての部署",
        departmentLoading: "部署一覧を読み込み中です",
        departmentFreeInput: "部署（自由入力）",
        departmentPartialSearch: "部署名で部分一致検索",
        name: "名前",
        qrCode: "QRコード",
        qrConfirmation: "QRコード確認",
        measurementItem: "検寸項目",
        specDimension: "指示寸法",
        measurementResult: "検寸結果",
        diff: "差寸",
        judgement: "判定",
        item: "アイテム",
        brand: "ブランド",
        final: "量産",
        sample: "サンプル",
        samplePhoto: "採寸撮影",
        ecPhoto: "EC撮影",
        identificationResult: "識別結果",
        weightResult: "重量結果(g)",
        pastSamples: "過去サンプル",
      },
      actions: {
        backToMeasurement: "検寸画面に戻る",
        filter: "絞り込み",
        filterSearch: "絞り込み検索",
        bulkCsvDownload: "一括CSVダウンロード",
        qrDisplay: "QR表示",
        measurementDisplay: "採寸表示",
        showPastMeasurements: "過去の採寸を表示",
        importSpecification: "仕様書取り込み",
        downloadMeasurementReport: "採寸表ダウンロード",
        downloadEcImages: "EC画像ダウンロード",
        downloadPastMeasurementReport: "過去の採寸表をダウンロード",
        showPastMeasurementsDescription: "表示中の採寸の過去の採寸表を表示",
        importSpecificationDescription: "指示寸法を入力(寸法を比較する)",
        downloadMeasurementReportDescription: "表示中の採寸表をpdfでダウンロード",
        downloadEcImagesDescription: "撮影したEC画像のみをダウンロード",
        downloadPastMeasurementReportDescription: "過去に採寸した採寸表をダウンロード",
        measurementDateAsc: "撮影日順(昇順)",
        measurementDateDesc: "撮影日順(降順)",
        checkDimensions: "寸法を確認",
        urlQrSearch: "url/QR 検索",
        clear: "CLEAR",
        add: "追加",
      },
      messages: {
        allDataLoaded: "すべてのデータを読み込み済みです。",
        allSamplesLoaded: "表示可能なサンプルはすべて読み込み済みです。",
        copyLinkSucceeded: "リンクをコピーしました。",
        unsavedChanges: "変更内容が保存されていません。",
        unsavedChangesConfirm: "変更内容が失われますがよろしいですか？",
        selectDownloadTarget: "ダウンロード対象を選択してください。",
        downloadFailedRetry: "ダウンロードに失敗しました。時間をおいて再度お試しください。",
        pdfDownloadFailedRetry: "PDFのダウンロードに失敗しました。\n時間をおいて再度お試しください。",
        filterDateNote: "撮影日 ※どちらか一つでも検索できます",
        qrScanGuide: "コードをスキャンするには、スマートフォンのQRスキャンアプリまたはカメラアプリを使用してください。",
        downloadSelectionLimitExceeded: "{{count}}件を超える選択はダウンロードできません。",
        downloadProcessingFailedRetry: "ダウンロード処理中にエラーが発生しました。時間をおいて再度お試しください。",
        downloadTimeoutRetry: "ダウンロードがタイムアウトしました。時間をおいて再度お試しください。",
        selectDownloadImages: "ダウンロードする画像を選択してください。",
        loadingSamples: "サンプル一覧を読み込み中です…",
        allReadableSamplesLoaded: "読み込めるサンプルはすべて表示済みです。",
        loadingSpecificationHistory: "仕様書履歴を読み込み中です…",
        allSpecificationHistoryLoaded: "すべての履歴を読み込み済みです。",
        allDisplayableHistoryLoaded: "表示可能な履歴はすべて読み込み済みです。",
        previewFetchFailed: "プレビューの取得に失敗しました。",
        previewLoadFailed: "プレビューを読み込めませんでした。",
        preparingPreview: "プレビューを準備中です...",
        noPreview: "表示可能なプレビューがありません。",
        representativeSampleMissing: "代表サンプルIDを取得できませんでした。",
        previewAcquireFailed: "プレビュー取得に失敗しました。",
        downloadTargetNotSelected: "ダウンロード対象が選択されていません。",
        selectedGroupHasNoValidSample: "選択されたグループに有効なサンプルがありません。",
        sampleNotFound: "指定したサンプルが見つかりませんでした。",
        sampleFetchFailed: "サンプルの取得に失敗しました。",
        sampleSaveSucceeded: "saveしました。",
        duplicateSampleExists: "同じサンプルが存在しています。",
        confirmInput: "入力内容を確認してください。",
        sampleSaveFailed: "saveできませんでした。",
        retrySaveButton: "再度saveボタンをクリックしてください。",
        measurementNameMissing: "採寸箇所名が未設定のデータがあります。",
        relatedSampleNotFound: "該当サンプルが見つかりませんでした。",
        linkPastSamplesConfirm: "過去サンプルも併せて紐付けしますか？",
        linkPastSamplesNote: "※SAVEを行うまで実行されません",
        resolutionUnknown: "解像度を特定できませんでした。デバイス設定やサンプルデータを確認してください。",
        selectMeasurementImageForManual: "採寸撮影画像を選択してください。EC画像では手動計測できません。",
        invalidResolution: "解像度が不正のため計測できません。デバイス設定やサンプルデータを確認してください。",
        selectMeasurementImageToAdd: "採寸箇所を追加するには、採寸撮影画像を選択してください。",
        loadMeasurementImageBeforeManual: "手動計測を開始するには、採寸撮影画像を読み込んでから画像を選択してください。",
        deleteMeasurementItemConfirm: "採寸項目を削除しますか？",
        restoreDeletedAutoMeasurementConfirm: "削除した自動採寸箇所を復活させますか？",
        measurementItemAlreadyExists: "\"{{name}}\"はすでに存在しています。",
        overwriteConfirm: "上書きしますか？",
        autoMeasurementOverwriteConfirm: "こちらは自動採寸データです。\n手動採寸で上書きしますか？",
        unnamedMeasurementExists: "既に採寸箇所が未設定のデータが存在します。",
        genericRegistrationFailed: "登録に失敗しました。",
        valueEmpty: "値が空です。",
        problemValue: "問題の値:",
        duplicateDataExists: "重複データがあります。",
        overwriteAndSaveConfirm: "上書きして保存しますか？",
        csvDuplicateMessage: "CSVの{{rows}}と既存データが重複しています。",
        csvFixAndUpload: "CSV{{rowText}}を修正して再度アップロードしてください。",
      },
      pages: {
        qrImage: "QR 画像",
        measurementEcImage: "採寸/EC 画像",
        pastMeasurements: "過去の採寸の表示",
        measurementResults: "採寸結果",
        bulkSpecificationDownload: "複数仕様書ダウンロード",
        specificationHistory: "仕様書履歴",
        brandOption: "ブランドオプション",
        shootingImage: "撮影画像",
        specificationImport: "仕様書インポート",
        specificationImportHistory: "仕様書インポート履歴",
        specificationRegister: "仕様書登録",
      },
      accessibility: {
        selectItem: "{{label}} を選択",
        checkedCheckbox: "選択済みチェックボックス",
        uncheckedCheckbox: "未選択チェックボックス",
        previewImage: "プレビュー画像",
        showSizeCandidates: "サイズ候補を表示",
        measurementImage: "採寸画像 {{index}}",
      },
      placeholders: {
        partNumberInput: "品番入力",
        sampleNumberInput: "サンプルNo入力",
        sizeInput: "サイズ入力",
        colorInput: "Color入力",
        itemNameInput: "アイテム名入力",
        brandNameInput: "ブランド名入力",
        pants: "パンツ",
        exampleBrandName: "例: ブランド名",
        exampleTshirt: "例: Tシャツ",
        examplePartNumber: "例: PN-123456",
        exampleSampleNumber: "例: SN-123456",
        exampleRepeat: "例: 1",
        exampleWhite: "例: White",
        exampleFactory: "例: factory",
        examplePatternNumber: "例: P-123456",
        measurementItemInput: "採寸項目を入力",
        exampleMeasurementItem: "例:着丈",
        exampleMeasurementValue: "例: 70.5",
      },
      specification: {
        dropFile: "仕様書をドロップ",
        or: "または",
        selectFile: "ファイルを選択",
        brandOrCustomerName: "ブランド名 or 顧客名",
        productionOrSample: "量産 or サンプル",
        dateOrCreatedAt: "日付 or 作成日",
        factoryName: "工場名",
        patternNumber: "パターンNo",
        measurementItemName: "採寸項目名",
        measurementValue: "採寸値",
        operation: "操作",
        csvRow: "{{row}}行目",
        csvRowFallback: "行目",
        validation: {
          timeRequired: "サンプルの場合、サンプル状況を選択してください。",
          sizeRequired: "サイズは必須です。",
          repeatRequired: "リピートは必須です。",
          itemRequired: "アイテム名は必須です。",
          itemsRequired: "採寸項目は必須です。",
          itemTitleRequired: "採寸項目名は必須です。",
          itemTitleDuplicate: "採寸項目名が重複しています。",
          itemValueInvalid: "採寸項目の値が不正です。",
          brandRequired: "ブランド名 or 顧客名 は必須です。",
          repeatInvalid: "リピートは数値で入力してください。",
          repeatMin: "リピートは0以上で入力してください。",
          partOrSampleRequired: "品番またはサンプルNoのどちらかは必須です。",
          kindRequired: "量産 or サンプル は必須です。",
          kindInvalid: "量産 or サンプル に無効な値が入力されています。",
          invalidDesignedAt: "日付 or 作成日 が不正です。日付形式を確認してください。",
          designedAtRequired: "日付 or 作成日は必須です。",
          headerMissing: "CSVヘッダーに必須カラムが不足しています。",
          headerInvalid: "CSVヘッダーに不正なカラム名が含まれています。",
          partNumberInvalid: "品番は半角英数字・ハイフン・アンダースコアのみ入力できます。",
          sampleNumberInvalid: "サンプルNoは半角英数字・ハイフン・アンダースコアのみ入力できます。",
          patternNumberInvalid: "パターンNoは半角英数字・ハイフン・アンダースコアのみ入力できます。",
          itemValueRequired: "採寸項目の値は必須です。",
          itemValueMin: "採寸項目の値は0以上で入力してください。",
        },
      },
      drawing: {
        mode: "描画モード",
        moveMode: "移動モード",
        moving: "描画中",
        moveHelpLabel: "移動:",
        moveHelp: "Spaceキー+ドラッグ または ホイール押下+ドラッグ",
        zoomHelpLabel: "ズーム:",
        zoomHelp: "{{modifier}}キー+マウスホイール",
        lineColor: "線色",
        measurementPoint: "採寸箇所",
        deleteItem: "項目削除",
      },
      sizeGroups: {
        ladiesAndMens: "レディース/メンズ",
        kids: "KIDS",
        mailOrderBrand: "通販ブランド",
        freeSize: "フリーサイズ",
      },
    } as const;
